'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const item = css`
  display: grid;
  grid-template-columns: 24px 1fr;
  grid-template-areas: 'icon details';
  gap: 0.5rem;
  align-items: center;
`;

export const icon = css`
  grid-area: icon;
  color: ${theme.colors.peoople['gris-medio']};
`;

export const details = css`
  grid-area: details;
  color: ${theme.colors.peoople['gris-medio']};
  font-weight: 600;
  font-size: 18px;
  &:hover {
    color: ${theme.colors.peoople['gris-oscuro']};
  }
  &[role='button'] {
    cursor: pointer;
  }
`;

export const map = css`
  width: 100%;
  height: 400px;
  position: relative;
  border-radius: 0.5rem;
  overflow: hidden;
`;

export const title = css`
  font-weight: 700;
  font-size: 18px;
`;

export const workingHours = css`
  display: grid;
  grid-template-columns: 1fr auto;
  text-align: right;
  gap: 1.5rem;
`;

export const workingHoursDay = css`
  display: flex;
  align-items: center;
  text-transform: capitalize;
  color: ${theme.colors.peoople['gris-medio']};
  font-weight: 600;
`;

export const workingHoursTime = css`
  color: ${theme.colors.peoople['gris-medio-claro']};
  font-weight: 600;
`;
